import React from 'react';
import { Brain, Users, Wrench, BookOpen, Award, BookType } from 'lucide-react';

const features = [
  {
    title: 'AI-Powered Quiz',
    description: 'Get personalized course recommendations based on your interests and goals',
    icon: Brain
  },
  {
    title: 'Community',
    description: 'Join our thriving community of drone enthusiasts and experts',
    icon: Users
  },
  {
    title: 'Build Your Drone',
    description: 'Design and build custom drones with interactive tools',
    icon: Wrench
  },
  {
    title: 'E-Library',
    description: 'Access comprehensive academic resources and research materials',
    icon: BookOpen
  },
  {
    title: 'Skill Badges',
    description: 'Earn recognition with our micro-learning certification program',
    icon: Award
  },
  {
    title: 'Scholar Platform',
    description: 'Publish your work and contribute to the drone knowledge base',
    icon: BookType
  }
];

function Features() {
  return (
    <div className="bg-light py-5">
      <div className="container">
        <h2 className="text-center mb-4">Our Features</h2>
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          {features.map((feature, index) => (
            <div className="col" key={index}>
              <div className="card shadow-lg hover-shadow-xl border-0 p-4">
                <div className="card-body text-center">
                  {/* Icon */}
                  <feature.icon className="mb-4" style={{ width: '50px', height: '50px', color: '#0d6efd' }} />
                  <h5 className="card-title">{feature.title}</h5>
                  <p className="card-text text-muted">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Features;
